<!-- 关于dnn -->
<template>
  <div class="about_dnn_container">
    <div class="wrapper">
      <footer class="aside-ft">
        <SamplePagination
          :total="3"
          :pageSize="1"
          theme="dark"
          :currentPage="currentPage"
          @current-change="handleCurrentChange"
        />
      </footer>
      <el-carousel
        indicator-position="none"
        :loop="true"
        :interval="8000"
        arrow="never"
        :autoplay="true"
        height="400px"
        ref="carouse"
        @change="handerChange"
      >
        <el-carousel-item v-for="(item, index) in dnnList" :key="index">
          <aside class="about-aside">
            <header
              class="aside-hd"
              v-scroll-animate="{ animation: 'fadeInUp' }"
            >
              {{ item.title }}
            </header>
            <p
              class="aside-bd"
              v-scroll-animate="{ animation: 'fadeInUp', delay: 200 }"
            >
              {{ item.summery }}
            </p>
            <span class="line"></span>
          </aside>
          <article class="about-mian">
            <img
              class="c_img cursor-pointer"
              :src="item.picUrl"
              alt="轮播图"
              @click="openUrl(item)"
            />
          </article>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import SamplePagination from "@/components/SamplePagination.vue";
import about_dnn_1 from "@/assets/images/homeImg/about_dnn_1.png";
import about_dnn_2 from "@/assets/images/homeImg/about_dnn_2.png";
import about_dnn_3 from "@/assets/images/homeImg/about_dnn_3.png";
export default {
  name: "Banner",
  components: { SamplePagination },
  data() {
    return {
      currentPage: 1,
      dnnList: [
        {
          id: 1,
          picUrl: about_dnn_1,
          linkUrl: "",
          title: "关于狄诺尼",
          summery:
            "江苏狄诺尼信息技术有限责任公司成立于2018年。公司致力于为工程师提供基础设施全生命周期的数智化软件产品和解决方案。我们的产品应用于基础设施行业（特别是交通、城建）规划、设计、建造和运维全生命周期。我们的产品提升工作和协同效率，帮助客户积累宝贵的数据资产，挖掘和激活数据要素，构建基础设施的数字孪生模型。",
        },
        {
          id: 2,
          picUrl: about_dnn_2,
          linkUrl: "",
          title: "关于狄诺尼",
          summery:
            "伴随着中国公路和城市建设的大规模发展，狄诺尼的软件产品有着20余年的发展历史。共取得发明专利15项，软件著作权39项。狄诺尼的软件产品服务于千余家客户企业，服务20000多名设计师用户。近年来，帮助客户完成道路设计方案总里程约43000公里，互通立交1000余座。狄诺尼的智能建造产品在40多个重大基础设施工程建设中投入使用，为高速公路、特大型桥梁和隧道工程提供BIM+GIS三维可视化、协同管理、计划管理和进度跟踪、现场报验和质量控制、智能化安全监督，电子档案，等等。",
        },
        {
          id: 3,
          picUrl: about_dnn_3,
          linkUrl: "",
          title: "关于狄诺尼",
          summery:
            "江苏狄诺尼作为中国基础设施数字化的知名品牌，已有数字设计和智能建造两个产品线。设计产品线主要有：AIRoad(道路工程快速方案设计系统)、EICAD(集成交互式道路与立交设计系统)、VRRoad（道路驾驶模拟与安全评价系统）、Report 3D（三维汇报演示系统）、Delivery 3D（设计成果管理系统），等等。建造产品线包含：数字建设管理平台、智慧工地平台、智慧梁厂平台，等等。",
        },
      ],
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    /*
     * @Description: 打开链接
     * @MethodAuthor:  liulian
     * @Date: 2023-07-26 09:17:29
     * @param: ''
     */
    openUrl(item) {
      if (item.bannerLink) {
        window.open(item.bannerLink, "_blank");
      }
    },
    handerChange(index) {
      this.currentPage = index + 1;
    },
    handleCurrentChange({ pageIndex }) {
      console.log(`当前页: ${pageIndex}`);
      this.currentPage = pageIndex;
      this.$refs.carouse.setActiveItem(this.currentPage - 1);
    },
  },
};
</script>

<style lang="scss">
.about_dnn_container {
  padding: 80px 0;
  background: #fff;
  .wrapper {
    position: relative;
    width: 1200px;
    margin: 0 auto;
    height: 400px;
    .el-carousel__arrow {
      display: none;
    }
    .el-carousel__item {
      display: flex;
    }
    .aside-ft {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 60%;
      margin-top: 24px;
      height: 32px;
      background: #fff;
      z-index: 100;
      // .el-pagination button:disabled {
      //   color: #c0c4cc;
      //   background-color: #ffffff;
      //   cursor: not-allowed;
      // }
      // .page-info-tip {
      //   color: #333;
      // }
      // .el-pagination .btn-prev,
      // .el-pagination .btn-next {
      //   color: #333;
      // }
    }
    .about-aside {
      position: relative;
      flex: 1;
      padding-right: 60px;
      .aside-hd {
        margin-bottom: 24px;
        font-size: 24px;
        color: #333;
        line-height: 32px;
        text-align: left;
        font-style: normal;
        font-weight: bold;
      }
      .aside-bd {
        font-weight: 400;
        font-size: 16px;
        color: #333;
        line-height: 32px;
        text-align: justify;
        font-style: normal;
        height: calc(100% - 128px);
        text-indent: 2em;
      }
      .line {
        position: absolute;
        right: 0;
        top: 0;
        width: 4px;
        height: 107px;
        background: #0074db;
      }
    }
    .about-mian {
      width: 455px;
      height: 400px;
      margin-left: 16px;
      img {
        width: 455px;
        height: 400px;
        object-fit: cover;
      }
    }
  }
}
</style>
